import { LoadingDots } from "PFComponents/loading_dots";
import { Suspense } from "react";

export const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={<LoadingDots pageViewEnabled circlesEnabled circleSize="md" />}>{children}</Suspense>
);
